import { Building, Handshake, Rocket, CheckCircle, ShieldCheck, MessageSquare } from "lucide-react";
import { useScrollAnimation, useStaggeredAnimation } from "@/hooks/useScrollAnimation";
const Features = () => {
  const {
    ref: sectionRef,
    isVisible
  } = useScrollAnimation<HTMLElement>();
  const {
    ref: gridRef,
    visibleItems
  } = useStaggeredAnimation<HTMLDivElement>(6, 150);
  const featuresList = [{
    icon: <Building size={24} />,
    title: "Property Listings",
    description: "Create detailed property listings with multiple images, location data, and comprehensive specifications."
  }, {
    icon: <Handshake size={24} />,
    title: "Connect With Investors",
    description: "Get your properties in front of qualified investors looking for their next opportunity."
  }, {
    icon: <Rocket size={24} />,
    title: "Fast Transactions",
    description: "Streamlined process from listing to closing, with tools to track every step of the deal."
  }, {
    icon: <CheckCircle size={24} />,
    title: "Deal Management",
    description: "Track active and closed deals with detailed metrics on performance and timelines."
  }, {
    icon: <ShieldCheck size={24} />,
    title: "Secure Platform",
    description: "Built with security in mind, protecting your property data and transaction details."
  }, {
    icon: <MessageSquare size={24} />,
    title: "Super Link Sharing",
    description: "Share all of your active properties with stylish detail and robust security."
  }];
  return <section ref={sectionRef} className="py-16 bg-card/30">
      <div className="container mx-auto px-4 my-0">
        <div className={`text-center mb-12 transition-all duration-700 ${isVisible ? 'animate-fade-in-up' : 'opacity-0 translate-y-8'}`}>
          <h2 className="text-3xl font-bold mb-4">Why Choose <span className="text-godyspo-gold gradient-text">Go Dyspo</span></h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Our platform offers a more affordable and user-friendly experience than competitors,
            focusing on simplicity and efficiency.
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuresList.map((feature, index) => <div key={index} className={`bg-card p-6 rounded-lg border border-border hover-lift group transition-all duration-500 ${visibleItems.includes(index) ? 'animate-scale-in' : 'opacity-0 scale-95'}`}>
              <div className="h-12 w-12 flex items-center justify-center rounded-full bg-godyspo-gold/20 text-godyspo-gold mb-4 icon-bounce group-hover:animate-bounce-gentle">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-muted-foreground">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default Features;